module.exports = __webpack_public_path__ + "img/serive1.137b9d75.jpg";